export const getByPath = (obj, path) =>
  String(path || "")
    .split(".")
    .reduce((acc, key) => (acc == null ? acc : acc[key]), obj);

export const interpolate = (template, vars = {}) =>
  String(template ?? "").replace(/\{(\w+)\}/g, (_, key) =>
    vars[key] == null ? `{${key}}` : String(vars[key])
  );

export const createTranslator = (catalog, fallback) => (key, vars) => {
  const value = getByPath(catalog, key) ?? getByPath(fallback, key);
  if (typeof value === "string") return interpolate(value, vars);
  if (value != null) return value;
  return key;
};
